<template>
  <div v-if="ready">
    <ks-toast
      ref="newAppVersionToastAlert"
      styles="position: fixed; top: 65px; right: 25px;"
      bodyStyle="background-color: #ffc107 !important"
      :showClose="false"
    >
      <template #header>
        <button type="button" class="btn btn-light btn-sm" @click.prevent="hideVersionToast" v-if="!toastCollapse">Wait 5 Minutes ...</button>
        <div v-else>
          <button type="button" class="btn btn-light btn-sm" @click.prevent="showVersionToast" style="float: right">
            <i class="fas fa-hourglass-half"></i>
            {{ versionTimer }}
          </button>
        </div>
      </template>
      <template #body>
        <h5>
          <b>New App Version {{ newAppVersion }}</b>
        </h5>
        You Need the New App Version.
        <br />
        <ks-button color="dark" class="mt-2" @onClick="updateAppVersion" label="Click Here to Update Now" />
      </template>
    </ks-toast>

    <header v-if="computedBlocksHeader.length > 0" :class="[BlockHeaderClasses]">
      <div class="row">
        <component v-for="(block, i) in computedBlocksHeader" v-bind:key="'region_header_' + i" :is="block.component"></component>
      </div>
    </header>

    <div v-if="computedBlocksTopA.length > 0" :class="[BlockTopAClasses]">
      <div class="row">
        <component v-for="(block, i) in computedBlocksTopA" v-bind:key="'region_top_a_' + i" :is="block.component"></component>
      </div>
    </div>

    <div v-if="computedBlocksTopB.length > 0" :class="[BlockTopBClasses]">
      <div class="row">
        <component v-for="(block, i) in computedBlocksTopB" v-bind:key="i" :is="block.component"></component>
      </div>
    </div>

    <div :class="[BlockBodyClasses]">
      <div class="row">
        <transition name="slide-left" mode="out-in">
          <aside v-if="computedBlocksLeft.length > 0" :class="[bodyLeftClasses]" v-show="showLeftBlock">
            <div class="row">
              <component v-for="(block, i) in computedBlocksLeft" v-bind:key="i" :is="block.component"></component>
            </div>
          </aside>
        </transition>

        <div :class="{ col: screenSizeId >= 3, 'col-small': screenSizeId < 3, [bodyCenterClasses]: true }">
          <aside v-if="computedBlocksMainTop.length > 0" class="row" :class="[mainTopClasses]">
            <component v-for="(block, i) in computedBlocksMainTop" v-bind:key="i" :is="block.component"></component>
          </aside>

          <div :class="{ row: screenSizeId >= 3, [mainContentClasses]: true }">
            <main :class="{ 'col-12': screenSizeId >= 3, 'col-12-small': screenSizeId < 3 }">
              <router-view />
            </main>
          </div>

          <aside v-if="computedBlocksMainBottom.length > 0" class="row" :class="[mainBootomClasses]">
            <component v-for="(block, i) in computedBlocksMainBottom" v-bind:key="i" :is="block.component"></component>
          </aside>
        </div>

        <transition name="slide-right" mode="out-in">
          <aside v-if="computedBlocksRight.length > 0" :class="[bodyRightClasses]" v-show="showRightBlock">
            <div class="row">
              <component v-for="(block, i) in computedBlocksRight" v-bind:key="i" :is="block.component"></component>
            </div>
          </aside>
        </transition>
      </div>
    </div>

    <div v-if="computedBlocksBottomB.length > 0" :class="[BlockBottomBClasses]">
      <div class="row">
        <component v-for="(block, i) in computedBlocksBottomB" v-bind:key="i" :is="block.component"></component>
      </div>
    </div>

    <div v-if="computedBlocksBottomA.length > 0" :class="[BlockBottomAClasses]">
      <div class="row">
        <component v-for="(block, i) in computedBlocksBottomA" v-bind:key="i" :is="block.component"></component>
      </div>
    </div>

    <footer v-if="computedBlocksFooter.length > 0" :class="[BlockFooterClasses]">
      <div class="row">
        <component v-for="(block, i) in computedBlocksFooter" v-bind:key="i" :is="block.component"></component>
      </div>
    </footer>

    <left-drawer v-show="computedBlocksLeftDrawer.length > 0" :screenSize="screenSize" :screenSizeId="screenSizeId">
      <component v-for="(block, i) in computedBlocksLeftDrawer" v-bind:key="i" :is="block.component"></component>
    </left-drawer>

    <right-drawer v-show="computedBlocksRightDrawer.length > 0" :screenSize="screenSize" :screenSizeId="screenSizeId">
      <component v-for="(block, i) in computedBlocksRightDrawer" v-bind:key="i" :is="block.component"></component>
    </right-drawer>
  </div>
</template>
<script>
  import config from '@/config';
  import leftDrawer from '../left-drawer';
  import rightDrawer from '../right-drawer';
  import toast from '../toast';
  import moment from 'moment';

  export default {
    name: 'layout',
    components: {
      'left-drawer': leftDrawer,
      'right-drawer': rightDrawer,
      toast: toast,
    },
    props: {
      blocks: { default: null, type: Array },
    },
    created() {
      window.addEventListener('resize', this.windowResize);

      const socket = app.socket;
      socket.on('newAppVersionNotification', data => {
        try {
          if (app.auth.isAuth) {
            if (data.app_version !== this.newAppVersion) {
              this.newAppVersion = data.app_version;
              this.$refs.newAppVersionToastAlert.show();
            }
          }
        } catch (err) {
          console.log('KS-APP: ', err);
        }
      });
    },
    destroyed() {
      window.removeEventListener('resize', this.windowResize);
    },
    mounted() {
      setTimeout(() => {
        app['layout'] = this;
        this.ready = true;
      }, 1000);
    },
    computed: {
      screenSize() {
        if (this.windowWidth <= 575) {
          return 'xs';
        } else if (this.windowWidth >= 576 && this.windowWidth <= 767) {
          return 'sm';
        } else if (this.windowWidth >= 768 && this.windowWidth <= 992) {
          return 'md';
        } else if (this.windowWidth >= 993 && this.windowWidth <= 1200) {
          return 'lg';
        } else {
          return 'xl';
        }
      },

      screenSizeId() {
        if (this.windowWidth <= 575) {
          return 1;
        } else if (this.windowWidth >= 576 && this.windowWidth <= 767) {
          return 2;
        } else if (this.windowWidth >= 768 && this.windowWidth <= 992) {
          return 3;
        } else if (this.windowWidth >= 993 && this.windowWidth <= 1200) {
          return 4;
        } else {
          return 5;
        }
      },

      BlockHeaderClasses() {
        try {
          let containerClass = config.layout && config.layout.header.fluid ? 'container-fluid' : 'container';
          let CustomClasses =
            config.layout && config.layout.header.classes && Array.isArray(config.layout.header.classes)
              ? config.layout.header.classes.join(' ')
              : '';
          return `${containerClass} ${CustomClasses}`;
        } catch (err) {
          return '';
        }
      },
      BlockTopAClasses() {
        try {
          let containerClass = config.layout && config.layout.topA.fluid ? 'container-fluid' : 'container';
          let CustomClasses =
            config.layout && config.layout.topA.classes && Array.isArray(config.layout.topA.classes) ? config.layout.topA.classes.join(' ') : '';
          return `${containerClass} ${CustomClasses}`;
        } catch (err) {
          return '';
        }
      },
      BlockTopBClasses() {
        try {
          let containerClass = config.layout && config.layout.topB.fluid ? 'container-fluid' : 'container';
          let CustomClasses =
            config.layout && config.layout.topB.classes && Array.isArray(config.layout.topB.classes) ? config.layout.topB.classes.join(' ') : '';
          return `${containerClass} ${CustomClasses}`;
        } catch (err) {
          return '';
        }
      },
      BlockBodyClasses() {
        try {
          let containerClass = config.layout && config.layout.body.fluid ? 'container-fluid' : 'container';
          let CustomClasses =
            config.layout && config.layout.body.classes && Array.isArray(config.layout.body.classes) ? config.layout.body.classes.join(' ') : '';
          return `${containerClass} ${CustomClasses}`;
        } catch (err) {
          return '';
        }
      },
      BlockBottomAClasses() {
        try {
          let containerClass = config.layout && config.layout.bottomA.fluid ? 'container-fluid' : 'container';
          let CustomClasses =
            config.layout && config.layout.bottomA.classes && Array.isArray(config.layout.bottomA.classes)
              ? config.layout.bottomA.classes.join(' ')
              : '';
          return `${containerClass} ${CustomClasses}`;
        } catch (err) {
          return '';
        }
      },
      BlockBottomBClasses() {
        try {
          let containerClass = config.layout && config.layout.bottomB.fluid ? 'container-fluid' : 'container';
          let CustomClasses =
            config.layout && config.layout.bottomB.classes && Array.isArray(config.layout.bottomB.classes)
              ? config.layout.bottomB.classes.join(' ')
              : '';
          return `${containerClass} ${CustomClasses}`;
        } catch (err) {
          return '';
        }
      },
      BlockFooterClasses() {
        try {
          let containerClass = config.layout && config.layout.footer.fluid ? 'container-fluid' : 'container';
          let CustomClasses =
            config.layout && config.layout.footer.classes && Array.isArray(config.layout.footer.classes)
              ? config.layout.footer.classes.join(' ')
              : '';
          return `${containerClass} ${CustomClasses}`;
        } catch (err) {
          return '';
        }
      },
      bodyRightClasses() {
        try {
          let sizeClass = '';
          let CustomClasses = '';
          if (config.layout && config.layout.body && config.layout.body.layout && config.layout.body.layout.right) {
            sizeClass = config.layout.body.layout.right.size ? `col-${config.layout.body.layout.right.size}` : 'col-2';
            CustomClasses =
              config.layout.body.layout.right.classes && Array.isArray(config.layout.body.layout.right.classes)
                ? config.layout.body.layout.right.classes.join(' ')
                : '';
          }
          return `${sizeClass} ${CustomClasses}`;
        } catch (err) {
          return '';
        }
      },
      bodyLeftClasses() {
        try {
          let sizeClass = '';
          let CustomClasses = '';
          if (config.layout && config.layout.body && config.layout.body.layout && config.layout.body.layout.left) {
            sizeClass = config.layout.body.layout.left.size ? `col-${config.layout.body.layout.left.size}` : 'col-2';
            CustomClasses =
              config.layout.body.layout.left.classes && Array.isArray(config.layout.body.layout.left.classes)
                ? config.layout.body.layout.left.classes.join(' ')
                : '';
          }
          return `${sizeClass} ${CustomClasses}`;
        } catch (err) {
          return '';
        }
      },
      showLeftBlock() {
        return app.store.state.ks_app.layout_store.show_left_block;
      },
      showRightBlock() {
        return app.store.state.ks_app.layout_store.show_right_block;
      },
      bodyCenterClasses() {
        try {
          let CustomClasses = '';
          if (config.layout && config.layout.body && config.layout.body.layout && config.layout.body.layout.center) {
            CustomClasses =
              config.layout.body.layout.center.classes && Array.isArray(config.layout.body.layout.center.classes)
                ? config.layout.body.layout.center.classes.join(' ')
                : '';
          }
          return `${CustomClasses}`;
        } catch (err) {
          return '';
        }
      },
      mainTopClasses() {
        try {
          let CustomClasses = '';
          if (
            config.layout &&
            config.layout.body &&
            config.layout.body.layout &&
            config.layout.body.layout.center &&
            config.layout.body.layout.center.layout &&
            config.layout.body.layout.center.layout.mainTop
          ) {
            CustomClasses = Array.isArray(config.layout.body.layout.center.layout.mainTop)
              ? config.layout.body.layout.center.layout.mainTop.join(' ')
              : '';
          }
          return `${CustomClasses}`;
        } catch (err) {
          return '';
        }
      },

      mainContentClasses() {
        try {
          let CustomClasses = '';
          if (
            config.layout &&
            config.layout.body &&
            config.layout.body.layout &&
            config.layout.body.layout.center &&
            config.layout.body.layout.center.layout &&
            config.layout.body.layout.center.layout.content
          ) {
            CustomClasses = Array.isArray(config.layout.body.layout.center.layout.content)
              ? config.layout.body.layout.center.layout.content.join(' ')
              : '';
          }
          return `${CustomClasses}`;
        } catch (err) {
          return '';
        }
      },
      mainBootomClasses() {
        try {
          let CustomClasses = '';
          if (
            config.layout &&
            config.layout.body &&
            config.layout.body.layout &&
            config.layout.body.layout.center &&
            config.layout.body.layout.center.layout &&
            config.layout.body.layout.center.layout.mainBottom
          ) {
            CustomClasses = Array.isArray(config.layout.body.layout.center.layout.mainBottom)
              ? config.layout.body.layout.center.layout.mainBottom.join(' ')
              : '';
          }
          return `${CustomClasses}`;
        } catch (err) {
          return '';
        }
      },
      computedBlocksRightDrawer() {
        return this.filterBlocks('rightDrawer');
      },
      computedBlocksLeftDrawer() {
        return this.filterBlocks('leftDrawer');
      },
      computedBlocksHeader() {
        return this.filterBlocks('header');
      },
      computedBlocksTopA() {
        return this.filterBlocks('topA');
      },
      computedBlocksTopB() {
        return this.filterBlocks('topB');
      },
      computedBlocksLeft() {
        return this.filterBlocks('left');
      },
      computedBlocksMainTop() {
        return this.filterBlocks('mainTop');
      },
      computedBlocksMainBottom() {
        return this.filterBlocks('mainBottom');
      },
      computedBlocksRight() {
        return this.filterBlocks('right');
      },

      computedBlocksBottomB() {
        return this.filterBlocks('bottomB');
      },
      computedBlocksBottomA() {
        return this.filterBlocks('bottomA');
      },

      computedBlocksFooter() {
        return this.filterBlocks('footer');
      },
    },
    methods: {
      windowResize() {
        this.windowWidth = window.innerWidth;
      },
      filterBlocks(region) {
        return this.blocks.filter(block => block.region == region);
      },
      async updateAppVersion() {
        try {
          app.activePage.$refs.ref_loading_page.show();
          let ids = [`site-dynamic-v${app.version.number}`, `site-static-v${app.version.number}`];
          ids.forEach(id => caches.delete(id));
          await this.$store.dispatch('rms_ui/auth/refresh_token', { appVersion: this.newAppVersion });
          if (app.version.worker) app.version.worker.postMessage({ action: 'skipWaiting' }); // force update service worker
          window.location.reload(true);
        } catch (err) {
          window.location.reload(true);
        }
      },
      hideVersionToast() {
        this.$refs.newAppVersionToastAlert.showBody = false;
        this.toastCollapse = true;
        if (this.waitTimeSeconds === 300) {
          let interval = setInterval(() => {
            if (this.waitTimeSeconds >= 0) {
              this.versionTimer = moment().startOf('day').seconds(this.waitTimeSeconds).format('mm:ss');
              this.waitTimeSeconds = this.waitTimeSeconds - 1;
            } else {
              clearInterval(interval);
              this.waitTimeSeconds = 300;
              this.showVersionToast();
            }
          }, 1000);
        }
      },
      showVersionToast() {
        this.$refs.newAppVersionToastAlert.showBody = true;
        this.toastCollapse = false;
      },
    },
    data() {
      return {
        windowWidth: window.innerWidth,
        newAppVersion: process.env.APP_VERSION,
        toastCollapse: false,
        waitTimeSeconds: 300,
        versionTimer: null,
        ready: false,
      };
    },
  };
</script>
<style>
  .slide-right-enter-active,
  .slide-right-leave-active {
    transition: all 0.3s ease;
  }

  .slide-right-enter, .slide-right-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateX(100%);
  }

  .slide-right-leave {
    transform: translateX(0%);
  }

  .slide-left-enter-active,
  .slide-left-leave-active {
    transition: all 0.3s ease;
  }

  .slide-left-enter, .slide-left-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateX(-100%);
  }

  .slide-left-leave {
    transform: translateX(0%);
  }

  .col-small {
    /*-ms-flex-preferred-size: 0;
  flex-basis: 0;
  -ms-flex-positive: 1;
  -webkit-box-flex: 1;
  flex-grow: 1;*/
    min-width: 0;
    max-width: 100%;
    position: relative;
    width: 100%;
    padding-right: 0;
    padding-left: 0;
  }

  .col-12-small {
    -ms-flex: 0 0 100%;
    -webkit-box-flex: 0;
    flex: 0 0 100%;
    max-width: 100%;
    position: relative;
    width: 100%;
    /*padding-right: 18px;
  padding-left: 18px;*/
  }
</style>
